/**
 * The services page (`/services`): every service the studio lists, in the
 * home's rows. The home lists at most eight and links here with See all
 * services, as Upcoming events links to /events (Gabriel 2026-10-20, layout 1
 * Tighter). The frame copies the events page: breadcrumb, then the heading.
 * On a phone it is the app's Book screen (PhoneBookScreen).
 */

import { useSiteStudio } from '../api/site';
import { usePageMover } from '../pageMover';
import { PhoneBookScreen } from '../phone/PhoneBookScreen';
import { Services } from '../pieces/services';
import shared from '../styles/shared.module.css';
import { onLink } from '../ui/onLink';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';
import css from './ServicesPage.module.css';

/** Every service, under the page's own heading rather than the piece's. */
const ALL_SERVICES = { limit: 0, eyebrow: null, heading: null, intro: null };

export function ServicesPage() {
  usePageTitle('Services');
  const navigate = usePageMover();
  const studioName = useSiteStudio().data?.name;
  const phone = useAppScreens();
  // Below 768px the page is the Mini App's Book screen on its Services tab (Gabriel 2026-10-21).
  if (phone) return <PhoneBookScreen tab="services" />;
  return (
    <div className={css.page}>
      <div className={shared.wrap}>
        {studioName && (
          <nav className={css.crumbs} aria-label="Breadcrumb">
            <a href="/" onClick={onLink(() => navigate('/'))}>
              {studioName}
            </a>
            <span className={css.crumbSep} aria-hidden="true">
              /
            </span>
            <span className={css.crumbHere} aria-current="page">
              Services
            </span>
          </nav>
        )}
        <div className={`${shared.secHead} ${css.head}`}>
          <h1 className={shared.h2}>Services</h1>
        </div>
      </div>
      <Services options={ALL_SERVICES} />
    </div>
  );
}
